<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.xt">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-family:SimSun;font-size:18px;">稀土硅合金</span>
        </b>
      </p>
      <p>
        <span style="font-size:12pt;">
          <span style="font-size:12px;">Re Silicide:</span>
        </span>
      </p>
      <span style="font-size:12pt;">
        <span style="font-size:12px;">
          1.&nbsp;Re 30% min
          Ce/Re 55% min La/Re 30% min
        </span>
      </span>
      <p>
        <span style="font-size:12px;">2.&nbsp;Re 10% min Ce/Re 55% min La/Re 30% min</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        xt: require("../../../assets/img/common/xt.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/xtghj.vue